import { render } from "./RelationList.vue?vue&type=template&id=79af543b"
import script from "./RelationList.vue?vue&type=script&lang=js"
export * from "./RelationList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__